import { roundToCurrency } from "@/lib/currency";
import type { BillingCycleMonths, BillingCycleOption } from "@/types/resource";

export interface BillingCyclePricing {
  baseAmount: number;
  discountAmount: number;
  discountPercent: number;
  subtotal: number;
  tax: number;
  total: number;
  monthlyEquivalent: number;
  isEstimate: boolean;
}

interface CalculateBillingCyclePricingParams {
  monthlyPrice: number;
  months: BillingCycleMonths;
  vatRate: number;
  currency: string;
  backendOption?: BillingCycleOption;
}

/** Uses the backend quote when present and never invents a discount for an unquoted cycle. */
export function calculateBillingCyclePricing({
  monthlyPrice,
  months,
  vatRate,
  currency,
  backendOption,
}: CalculateBillingCyclePricingParams): BillingCyclePricing {
  const baseAmount = monthlyPrice * months;
  const subtotal = backendOption
    ? backendOption.totalPrice
    : roundToCurrency(baseAmount, currency);
  const tax = roundToCurrency((subtotal * vatRate) / 100, currency);

  return {
    baseAmount,
    discountAmount: backendOption ? baseAmount - subtotal : 0,
    discountPercent: backendOption?.discountPercent ?? 0,
    subtotal,
    tax,
    total: subtotal + tax,
    monthlyEquivalent: backendOption?.monthlyEquivalent ?? monthlyPrice,
    isEstimate: !backendOption,
  };
}
